/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * PHRMPC.Manning.Web.API | v1
 * OpenAPI spec version: 1.0.0
 */
import { z as zod } from 'zod';

export const getConcernsIssueTypeByIdIdRegExpTwo = new RegExp('^-?(?:0|[1-9]\\d*)$');


export const GetConcernsIssueTypeById = zod.object({
  "id": zod.union([zod.number(),zod.string().regex(getConcernsIssueTypeByIdIdRegExpTwo)]).optional()
});

export type GetConcernsIssueTypeById = zod.input<typeof GetConcernsIssueTypeById>;
export type GetConcernsIssueTypeByIdOutput = zod.output<typeof GetConcernsIssueTypeById>;
